/**
 * Entries API client.
 */
import { apiGet, apiPost, apiPut } from './client';
import type {
  EntryCreateResponseDto,
  EntryDetailDto,
  EntryUpdateRequestDto,
  SelectionsUpdateRequestDto,
  SubmitEntryRequestDto,
  SubmitEntryResponseDto,
  ProcessingStatusDto,
} from './types';

export const entriesApi = {
  /**
   * Create a new draft entry.
   */
  createDraft: (trialEventId: string, request?: { createdForUserEmail?: string }) =>
    apiPost<EntryCreateResponseDto>(`/trial-events/${trialEventId}/entries`, request ?? {}),

  /**
   * Get an entry by ID.
   */
  getById: (trialEventId: string, entryId: string) =>
    apiGet<EntryDetailDto>(`/trial-events/${trialEventId}/entries/${entryId}`),

  /**
   * Update entry fields (dog, contact, emergency contact, fees).
   */
  update: (trialEventId: string, entryId: string, data: EntryUpdateRequestDto, etag?: string) =>
    apiPut<EntryDetailDto>(`/trial-events/${trialEventId}/entries/${entryId}`, data, {
      headers: etag ? { 'If-Match': etag } : undefined,
    }),

  /**
   * Update grid selections.
   */
  updateSelections: (trialEventId: string, entryId: string, selections: SelectionsUpdateRequestDto) =>
    apiPut<EntryDetailDto>(`/trial-events/${trialEventId}/entries/${entryId}/selections`, selections),

  /**
   * Submit an entry.
   */
  submit: (trialEventId: string, entryId: string, request: SubmitEntryRequestDto) =>
    apiPost<SubmitEntryResponseDto>(`/trial-events/${trialEventId}/entries/${entryId}/submit`, request),

  /**
   * Get processing status (PDF/email status).
   */
  getProcessingStatus: (entryId: string) =>
    apiGet<ProcessingStatusDto>(`/admin/entries/${entryId}/processing-status`),
};
